import FirebaseContext from './context';
import Firebase from './firebase';

export default Firebase;
export { FirebaseContext };